import axios from "axios";
import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "./constant.js";
import Theme from "./Theme.js";
const Login = (index) => {
  const [username, setUserName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [status, setStatus] = useState("");
  const [errorMessages, setErrorMessages] = useState({});
  const navigate = useNavigate();
  const errors = {
    uname: "Username required",
    pass: "Password required",
  };
  const handelLogin = async () => {
    if (username === "") {
      setErrorMessages({ name: "uname", message: errors.uname });
    } else if (password === "") {
      setErrorMessages({ name: "pass", message: errors.pass });
    } else {
      try {
        const formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);
        let result = await axios.post(
          baseUrl + "authController/loginAuth",
          formData,
        );

        setStatus(result.data.message);
        if (result.data.status === 1) {
          localStorage.setItem("Name", await result.data.user_data.name);
          localStorage.setItem(
            "userCode",
            await result.data.user_data.unique_id,
          );
          localStorage.setItem("token", await result.data.user_data.token);
          localStorage.setItem(
            "firsttimelogin",
            await result.data.user_data.is_first_time_login,
          );
          if (result.data.user_data.is_first_time_login == 1) {
            navigate("/forgotpassword");
          } else {
            // navigate("/");
            navigate("/");
          }
        } else {
          setErrorMessages({ name: "apierror", message: result.data.message });
        }
      } catch (error) {
        setErrorMessages({
          name: "apierror",
          message: "Unable to connect to the login server. Please try again.",
        });
      }
    }
  };
  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <div className="error">{errorMessages.message}</div>
    );
  return (
    <>
      <section className="online_trade_view" key={index}>
        <div className="text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body __login_form_card">
                  <div className="login_form loginformdark">
                    {/* <div>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#color_modal"
                      >
                        <img
                          src="assets/img/icons/colour.png"
                          className="img-fluid color_icons"
                        />
                      </a>
                    </div> */}
                    <div className="logo_f text-center ">
                      <a href="#" className="logo">
                        <img
                          src="assets/img/logo1.png"
                          className="img-fluid"
                          alt="logo"
                        />
                      </a>
                    </div>

                    <div className="loginpageformdiv">
                      <form className="login_form_section">
                        <h4
                          className="homesignin"
                          style={{ textAlign: "left" }}
                        >
                          Sign In
                        </h4>
                        <div className="form-group form_fill_group">
                          {/* <label className="form_label">User Id</label> */}
                          <div className="form_icons">
                            <input
                              img
                              src="./accets/img/icons/1506603007.svg"
                              type="text"
                              name="name"
                              className="form-control "
                              placeholder="Enter Your user id."
                              value={username}
                              onChange={(e) => setUserName(e.target.value)}
                              required
                            />
                          </div>
                          {renderErrorMessage("uname")}
                        </div>
                        <div className="form-group form_fill_group">
                          {/* <label className="form_label">Password</label> */}
                          <div className="form_icons">
                            <input
                              type="Password"
                              name="name"
                              className="form-control logininput"
                              placeholder="Enter Your Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                          </div>
                          {renderErrorMessage("pass")}
                        </div>
                        {renderErrorMessage("apierror")}
                        <div className="form-group">
                          <button
                            type="button"
                            onClick={handelLogin}
                            className="btn btn-login"
                          >
                            Login
                          </button>
                        </div>
                      </form>
                    </div>
                    <div
                      className="homesignin"
                      style={{ marginTop: "15px", textAlign: "center" }}
                    >
                      <p
                        className="homesignin"
                        style={{
                          fontSize: "13px",

                          font_weight: "bold",
                        }}
                      >
                        
                        No real money is involved. This is a virtual training<br/>
                        application that provides all the features required for <br/>
                        educational practice.
                      </p>
                      <p
                        className="homesignin"
                        style={{
                          fontSize: "13px",

                          font_weight: "bold",
                        }}
                      >
                        {" "}
                        This application is intended solely for exchanging views and<br/>
                        information about the market for only educational purposes.
                      </p>
                      <p
                        className="homesignin"
                        style={{
                          fontSize: "13px",

                          font_weight: "bold",
                        }}
                      >
                        {" "}
                        OnlineMarketView is not liable for any real-money transactions.<br/>
                        We do not deal with or facilitate any real-money transactions.
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Login;
